import { useId } from "react";
import type { FC } from "react";

interface RotationToolProps {
	angle: number;
	onChange: (params: { angle: number }) => void;
}

export const RotationTool: FC<RotationToolProps> = ({ angle, onChange }) => {
	const sliderId = useId();

	return (
		<div className="p-4">
			<div className="mb-2 font-semibold">Rotation / Tilt</div>
			<label className="block text-xs mb-1" htmlFor={sliderId}>
				Angle: {angle}°
			</label>
			<input
				type="range"
				min={-45}
				max={45}
				id={sliderId}
				value={angle}
				onChange={(e) => onChange({ angle: Number(e.target.value) })}
			/>
			<button
				className="ml-2 px-2 py-1 rounded bg-blue-500 text-white"
				onClick={() => onChange({ angle: 0 })}
			>
				Level
			</button>
		</div>
	);
};
